module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 rooms"
  }, [_vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "room",
      on: {
        "click": function($event) {
          return _vm.showRoom(room.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(room.name) + "\n    ")])
  }), _vm._v(" "), _c('AddRoom')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dad18f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/twillo/Rooms.vue
// module id = 709
// module chunks = 1